module.exports = __webpack_public_path__ + "AvertaCyrillic-SemiBold.edba0f13ba9263f433e8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/AvertaCyrillic-SemiBold.ttf
// module id = ../../../../../src/assets/fonts/AvertaCyrillic-SemiBold.ttf
// module chunks = styles